export function BookMark() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.95312 21.2791C5.40313 21.2791 4.93246 21.0834 4.54113 20.6921C4.14979 20.3007 3.95379 19.8297 3.95312 19.2791V5.27905C3.95312 4.72905 4.14913 4.25839 4.54113 3.86705C4.93313 3.47572 5.40379 3.27972 5.95312 3.27905H19.9531C20.5031 3.27905 20.9741 3.47505 21.3661 3.86705C21.7581 4.25905 21.9538 4.72972 21.9531 5.27905V19.2791C21.9531 19.8291 21.7575 20.3001 21.3661 20.6921C20.9748 21.0841 20.5038 21.2797 19.9531 21.2791H5.95312ZM12.9531 12.2791L15.4531 10.7791L17.9531 12.2791V5.27905H12.9531V12.2791Z"
        fill="currentColor"
      />
    </svg>
  );
}
